import React, { FunctionComponent } from 'react';

const LIGHT_ROUNDED_STYLES = {
  backgroundColor: 'hsla(0,0%,100%,.3)',
  height: 32,
  width: 32,
  borderRadius: 3,
};

export const HeaderSkeleton: FunctionComponent<{
  backgroundColor?: string;
}> = ({ backgroundColor = '#00000026' }) => (
  <div
    style={{
      backgroundColor,
      height: 32,
      padding: 4,
      display: 'flex',
    }}
  >
    <div style={{ display: 'flex', flexGrow: 1 }}>
      <div
        style={{
          ...LIGHT_ROUNDED_STYLES,
          marginRight: 4,
        }}
      />
      <div
        style={{
          ...LIGHT_ROUNDED_STYLES,
          width: 90,
          marginRight: 4,
        }}
      />
      <div
        style={{
          ...LIGHT_ROUNDED_STYLES,
          width: 180,
        }}
      />
    </div>
    <div style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}>
      <div
        style={{
          ...LIGHT_ROUNDED_STYLES,
          marginRight: 4,
        }}
      />
      <div
        style={{
          ...LIGHT_ROUNDED_STYLES,
          marginRight: 4,
        }}
      />
      <div
        style={{
          ...LIGHT_ROUNDED_STYLES,
          marginRight: 4,
        }}
      />
      <div
        style={{
          ...LIGHT_ROUNDED_STYLES,
          marginRight: 4,
        }}
      />
      <div
        style={{
          ...LIGHT_ROUNDED_STYLES,
          borderRadius: '50%',
        }}
      />
    </div>
  </div>
);
